export default __webpack_public_path__ + "static/grenette-bold-pro-0a3a62d1742b208506e8970fe7603fd5.eot";